import { EXERCISES_DOMAIN } from '../../../../exercise/redux/constants'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import getReferencesSelector from '../../../../references/selectors/get'

function shouldKeepExerciseHook (instance, state) {
  const references = getReferencesSelector(getPathReduxUtil(instance))(state)
  return !references.every(refPath => {
    return refPath.startsWith(EXERCISES_DOMAIN)
  })
}

export { shouldKeepExerciseHook }
